import { type ChangeEventHandler, type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Radio, Rating } from 'base-ui'

import {
  RATING_DEFAULT_VALUES,
  type RatingRange,
} from '../ProductSearchRefinementStateContext'

type ProductSearchRefinementRatingItemProps = {
  currentRating: RatingRange
  onChange: ChangeEventHandler<HTMLInputElement> | undefined
  stars: number
}

const RATING_INPUT_NAME = 'rating'

export const ProductSearchRefinementRatingItem: FC<
  ProductSearchRefinementRatingItemProps
> = ({ currentRating, onChange, stars }) => {
  return (
    <label className="flex items-center gap-2 py-2 text-m leading-m text-dark-primary-max">
      <Radio
        checked={stars === currentRating.ratingMin}
        className="shrink-0"
        data-qa-id={`form-e-rating-star-${stars}`}
        name={RATING_INPUT_NAME}
        onChange={onChange}
        size="small"
        value={stars}
      />
      <Rating className="text-2xl" key={stars} readOnly value={stars} />
      {stars !== RATING_DEFAULT_VALUES.ratingMax && (
        <span className="text-xs text-dark-primary-strong">
          <FormattedMessage id="searchResults.label.andMore" />
        </span>
      )}
    </label>
  )
}
